import { Colors } from '@sigma-frontend-libs/commons'

import { icons, isEmpty, sizes } from '@/utils'

import squircle from '@/components/icon/squircle'
import { serviceNameViaPoint } from '@/components/services/url-shortener-settings/presets/utils'

export default function(h) {
  if (isEmpty(this.value?.characters)) {
    return
  }

  return h(
    squircle,
    {
      props: {
        tooltip: this.getTranslate(
          `${serviceNameViaPoint}.hints.generationParams.templates.characters`,
          { characters: this.value?.characters }
        ),
        icon: icons.abc,
        color: Colors.grey,
        size: sizes.medium
      }
    }
  )
}
